(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["background-signature"] && !Shopify.designMode) return;
  try {
    class BackgroundSignature extends HTMLElement {
    constructor() {
      super();
      this.animation = null;
      this.observer = null;
      this.hasPlayed = false;
      this.init();
    }

    init() {
      this.lottieContainer = this.querySelector('.background-signature__lottie');
      this.lottiePath = this.dataset.lottiePath;
      this.shouldLoop = this.dataset.lottieLoop === 'true';
      this.speed = parseFloat(this.dataset.lottieSpeed) || 1;
      this.animationId = this.dataset.animationId;

      if (!this.lottieContainer || !this.lottiePath) return;

      // Find the parent section to observe
      this.sectionElement = this.closest('section') || this.closest('[id]') || this.parentElement;

      // Wait for Lottie library to load if not already available
      if (typeof lottie === 'undefined') {
        this.waitForLottie();
      } else {
        this.setupAnimation();
      }
    }

    waitForLottie() {
      const checkLottie = () => {
        if (typeof lottie !== 'undefined') {
          this.setupAnimation();
        } else {
          setTimeout(checkLottie, 100);
        }
      };
      checkLottie();
    }

    setupAnimation() {
      if (typeof lottie === 'undefined') return;

      // Check if animation already exists for this container
      if (this.lottieContainer.querySelector('svg') || this.animation) {
        return; // Animation already loaded
      }

      // Load the Lottie animation without autoplay
      this.animation = lottie.loadAnimation({
        container: this.lottieContainer,
        renderer: 'svg',
        loop: this.shouldLoop,
        autoplay: false, // Don't autoplay - wait for viewport intersection
        path: this.lottiePath,
        speed: this.speed,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid meet',
          className: 'background-signature__lottie-svg',
        },
      });

      // Handle animation events
      this.animation.addEventListener('complete', () => {
        if (!this.shouldLoop) {
          // Keep the final frame visible
          this.lottieContainer.style.opacity = '1';
        }
      });

      this.animation.addEventListener('loopComplete', () => {
        // Optional: Add any loop-specific behavior here
      });

      // Set up intersection observer to trigger animation on viewport entry
      this.setupIntersectionObserver();
    }

    setupIntersectionObserver() {
      // In theme editor, play immediately
      if (Shopify && Shopify.designMode) {
        this.playAnimation();
        return;
      }

      // Use Intersection Observer to trigger animation when section enters viewport
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1, // Trigger when 10% of the element is visible
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.hasPlayed) {
            this.playAnimation();
            // If animation doesn't loop, disconnect observer after playing
            if (!this.shouldLoop) {
              this.observer.disconnect();
            }
          }
        });
      }, options);

      // Observe the section element (parent section) or the signature element itself
      if (this.sectionElement) {
        this.observer.observe(this.sectionElement);
      } else {
        this.observer.observe(this);
      }
    }

    playAnimation() {
      if (this.animation && !this.hasPlayed) {
        this.animation.play();
        this.hasPlayed = true;
      }
    }

    connectedCallback() {
      // Reinitialize when section is reloaded in theme editor
      if (Shopify && Shopify.designMode) {
        // Only reinitialize if not already initialized
        if (!this.animation && !this.lottieContainer.querySelector('svg')) {
          this.init();
        } else if (this.animation && !this.hasPlayed) {
          this.playAnimation();
        }
      }
    }

    disconnectedCallback() {
      // Clean up animation and observer when element is removed
      if (this.observer) {
        this.observer.disconnect();
      }
      if (this.animation) {
        this.animation.destroy();
      }
    }
  }

  if (!customElements.get('background-signature')) {
    customElements.define('background-signature', BackgroundSignature);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["carousel"] && !Shopify.designMode) return;
  try {
    class CarouselComponent extends HTMLElement {
    constructor() {
      super();
      this.isLooping = false;
      this.isScrolling = false;
      this.initialized = false;
    }

    connectedCallback() {
      // Only initialize once, or reinitialize in design mode
      if (!this.initialized || (Shopify && Shopify.designMode)) {
        this.init();
      }
    }

    init() {
      this.container = this.querySelector('.carousel__container');
      this.leftBtn = this.querySelector('.carousel__nav-btn--left');
      this.rightBtn = this.querySelector('.carousel__nav-btn--right');
      this.loop = this.dataset.loop === 'true';

      if (!this.container || !this.leftBtn || !this.rightBtn) return;

      // Get original items before any cloning
      this.originalItems = Array.from(this.container.children).filter((item) => !item.hasAttribute('data-clone'));
      this.itemCount = this.originalItems.length;

      // Setup infinite loop if enabled and we have items
      if (this.loop && this.itemCount > 0) {
        this.setupInfiniteLoop();
      }

      // Add event listeners
      this.leftBtn.addEventListener('click', () => this.scrollToPrev());
      this.rightBtn.addEventListener('click', () => this.scrollToNext());
      this.container.addEventListener('scroll', () => this.handleScroll(), { passive: true });
      this.container.addEventListener('scrollend', () => this.handleScrollEnd());

      // Update on resize
      this.handleResize = () => {
        this.updateButtons();
      };
      window.addEventListener('resize', this.handleResize);

      // Initial state
      requestAnimationFrame(() => {
        this.updateButtons();
      });

      this.initialized = true;
    }

    setupInfiniteLoop() {
      // Remove any existing clones first
      this.container.querySelectorAll('[data-clone]').forEach((clone) => clone.remove());

      // Clone all items to prepend and append for seamless loop
      const clonesBefore = [];
      const clonesAfter = [];

      this.originalItems.forEach((item) => {
        const cloneBefore = item.cloneNode(true);
        const cloneAfter = item.cloneNode(true);
        cloneBefore.setAttribute('data-clone', 'before');
        cloneAfter.setAttribute('data-clone', 'after');
        clonesBefore.push(cloneBefore);
        clonesAfter.push(cloneAfter);
      });

      // Prepend clones (in reverse order so they appear in correct sequence)
      clonesBefore.reverse().forEach((clone) => {
        this.container.insertBefore(clone, this.container.firstChild);
      });

      // Append clones
      clonesAfter.forEach((clone) => {
        this.container.appendChild(clone);
      });

      // Set initial scroll position to first original item after layout
      // Use multiple rAF to ensure layout is complete
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.scrollToFirstOriginal(false);
          });
        });
      });
    }

    scrollToFirstOriginal(smooth = false) {
      if (!this.loop || this.originalItems.length === 0) return;

      const firstOriginal = this.originalItems[0];
      if (firstOriginal) {
        const padding = this.getContainerPadding();
        // Scroll so the first original item aligns with the left padding edge
        const scrollPos = firstOriginal.offsetLeft - padding;

        // Disable scroll-snap temporarily to avoid interference
        this.container.style.scrollSnapType = 'none';
        this.container.scrollLeft = scrollPos;

        // Re-enable scroll-snap after a brief delay
        requestAnimationFrame(() => {
          this.container.style.scrollSnapType = 'x mandatory';
        });
      }
    }

    getContainerPadding() {
      const style = window.getComputedStyle(this.container);
      return parseFloat(style.paddingLeft) || 0;
    }

    handleScroll() {
      this.isScrolling = true;
      this.updateButtons();
    }

    handleScrollEnd() {
      this.isScrolling = false;

      if (this.loop && !this.isLooping) {
        this.checkAndResetLoop();
      }
    }

    checkAndResetLoop() {
      if (this.isLooping || this.itemCount === 0) return;

      const padding = this.getContainerPadding();
      const scrollLeft = this.container.scrollLeft;

      // Get positions of original items
      const firstOriginal = this.originalItems[0];
      const lastOriginal = this.originalItems[this.itemCount - 1];

      if (!firstOriginal || !lastOriginal) return;

      const firstOriginalLeft = firstOriginal.offsetLeft - padding;
      const lastOriginalRight = lastOriginal.offsetLeft + lastOriginal.offsetWidth - padding;

      // Calculate the total width of original content (including gaps)
      const gap = this.getItemGap();
      const totalOriginalWidth = lastOriginalRight - firstOriginalLeft + gap;

      // Check if we've scrolled into the "after" clones
      if (scrollLeft >= lastOriginalRight - 10) {
        this.isLooping = true;
        const newScrollPos = scrollLeft - totalOriginalWidth;
        this.container.scrollTo({ left: newScrollPos, behavior: 'instant' });
        requestAnimationFrame(() => {
          this.isLooping = false;
        });
      }

      // Check if we've scrolled into the "before" clones
      const beforeClonesEnd = firstOriginalLeft;
      if (scrollLeft < beforeClonesEnd - this.container.clientWidth + padding) {
        this.isLooping = true;
        const newScrollPos = scrollLeft + totalOriginalWidth;
        this.container.scrollTo({ left: newScrollPos, behavior: 'instant' });
        requestAnimationFrame(() => {
          this.isLooping = false;
        });
      }
    }

    getItemGap() {
      const style = window.getComputedStyle(this.container);
      return parseFloat(style.gap) || 24;
    }

    updateButtons() {
      if (this.loop) {
        // For looping carousels, buttons are always visible
        return;
      }

      const scrollLeft = this.container.scrollLeft;
      const scrollWidth = this.container.scrollWidth;
      const clientWidth = this.container.clientWidth;

      const isAtStart = scrollLeft <= 1;
      const isAtEnd = scrollLeft + clientWidth >= scrollWidth - 1;

      this.leftBtn.classList.toggle('visible', !isAtStart);
      this.rightBtn.classList.toggle('visible', !isAtEnd);
    }

    getAllItems() {
      return Array.from(this.container.children);
    }

    scrollToPrev() {
      const items = this.getAllItems();
      const padding = this.getContainerPadding();
      const currentScroll = this.container.scrollLeft;

      // Find the item that we should scroll to (previous item from current position)
      let targetItem = null;
      for (let i = items.length - 1; i >= 0; i--) {
        const item = items[i];
        const itemLeft = item.offsetLeft - padding;
        // Find an item that's clearly before our current scroll position
        if (itemLeft < currentScroll - 10) {
          targetItem = item;
          break;
        }
      }

      if (targetItem) {
        const targetPos = targetItem.offsetLeft - padding;
        this.container.scrollTo({ left: targetPos, behavior: 'smooth' });
      }
    }

    scrollToNext() {
      const items = this.getAllItems();
      const padding = this.getContainerPadding();
      const currentScroll = this.container.scrollLeft;

      // For non-looping carousels, calculate max scroll position
      // where last item is fully visible (aligned to right edge)
      if (!this.loop && items.length > 0) {
        const lastItem = items[items.length - 1];
        const maxScroll = lastItem.offsetLeft + lastItem.offsetWidth - this.container.clientWidth + padding;

        if (currentScroll >= maxScroll - 10) {
          return; // Already at end, don't scroll further
        }
      }

      // Find the next item to scroll to
      let targetItem = null;
      for (const item of items) {
        const itemLeft = item.offsetLeft - padding;
        // Find an item that's clearly after our current scroll position
        if (itemLeft > currentScroll + 10) {
          targetItem = item;
          break;
        }
      }

      if (targetItem) {
        let targetPos = targetItem.offsetLeft - padding;

        // For non-looping carousels, cap at max scroll position
        if (!this.loop && items.length > 0) {
          const lastItem = items[items.length - 1];
          const maxScroll = lastItem.offsetLeft + lastItem.offsetWidth - this.container.clientWidth + padding;
          targetPos = Math.min(targetPos, maxScroll);
        }

        this.container.scrollTo({ left: targetPos, behavior: 'smooth' });
      }
    }

    disconnectedCallback() {
      if (this.handleResize) {
        window.removeEventListener('resize', this.handleResize);
      }
    }
  }

  if (!customElements.get('carousel-component')) {
    customElements.define('carousel-component', CarouselComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dropdown"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const dropdowns = document.querySelectorAll('[data-dropdown]');

    dropdowns.forEach(function (dropdown) {
      const trigger = dropdown.querySelector('[data-dropdown-trigger]');
      const menu = dropdown.querySelector('[data-dropdown-menu]');
      const options = dropdown.querySelectorAll('[data-dropdown-option]');
      const select = dropdown.querySelector('.dropdown__select');
      const label = dropdown.querySelector('.dropdown__label');

      if (!trigger || !menu || !select || !label) return;

      // Toggle dropdown
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const isExpanded = dropdown.getAttribute('data-state') === 'expanded';

        // Close all other dropdowns
        document.querySelectorAll('[data-dropdown]').forEach(function (dd) {
          if (dd !== dropdown && dd.getAttribute('data-state') === 'expanded') {
            dd.setAttribute('data-state', 'collapsed');
            dd.querySelector('[data-dropdown-trigger]').setAttribute('aria-expanded', 'false');
          }
        });

        // Toggle current dropdown
        if (isExpanded) {
          dropdown.setAttribute('data-state', 'collapsed');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          dropdown.setAttribute('data-state', 'expanded');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });

      // Handle option selection
      options.forEach(function (option) {
        option.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          const value = option.getAttribute('data-value');
          const optionLabel = option.querySelector('.dropdown__option-label').textContent;

          // Update select element
          select.value = value;
          select.dispatchEvent(new Event('change', { bubbles: true }));

          // Update label
          label.textContent = optionLabel;

          // Update active state
          options.forEach(function (opt) {
            opt.classList.remove('dropdown__option--active');
            opt.setAttribute('aria-selected', 'false');
          });
          option.classList.add('dropdown__option--active');
          option.setAttribute('aria-selected', 'true');

          // Close dropdown
          dropdown.setAttribute('data-state', 'selected');
          trigger.setAttribute('aria-expanded', 'false');
        });
      });

      // Close dropdown when clicking outside
      document.addEventListener('click', function (e) {
        if (!dropdown.contains(e.target)) {
          dropdown.setAttribute(
            'data-state',
            dropdown.querySelector('.dropdown__option--active') ? 'selected' : 'collapsed',
          );
          trigger.setAttribute('aria-expanded', 'false');
        }
      });

      // Close dropdown on Escape key
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && dropdown.getAttribute('data-state') === 'expanded') {
          dropdown.setAttribute(
            'data-state',
            dropdown.querySelector('.dropdown__option--active') ? 'selected' : 'collapsed',
          );
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
        }
      });

      // Reset Handler
      const parentForm = dropdown.closest('form');
      if (parentForm) {
        parentForm.addEventListener('reset', function () {
          setTimeout(() => {
            const currentValue = select.value;
            let matchedOption = null;

            options.forEach((opt) => {
              if (opt.getAttribute('data-value') === currentValue) {
                matchedOption = opt;
              }
            });

            options.forEach((opt) => {
              opt.classList.remove('dropdown__option--active');
              opt.setAttribute('aria-selected', 'false');
            });

            if (matchedOption) {
              label.textContent = matchedOption.querySelector('.dropdown__option-label').textContent;
              matchedOption.classList.add('dropdown__option--active');
              matchedOption.setAttribute('aria-selected', 'true');
              dropdown.setAttribute('data-state', 'selected');
            } else {
              label.textContent = select.options[0].textContent;
              dropdown.setAttribute('data-state', 'collapsed');
            }
          }, 0);
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["foldout"] && !Shopify.designMode) return;
  try {
    class FoldoutComponent extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.items = this.querySelectorAll('[data-foldout-item]');

      if (!this.items.length) return;

      // Bind methods
      this.toggle = this.toggle.bind(this);

      // Add event listeners (all items start collapsed)
      this.items.forEach((item, index) => {
        const trigger = item.querySelector('[data-foldout-trigger]');
        if (trigger) {
          trigger.addEventListener('click', () => this.toggle(item));
        }
      });
    }

    toggle(item) {
      const trigger = item.querySelector('[data-foldout-trigger]');
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        this.close(item);
      } else {
        this.open(item);
      }
    }

    open(item) {
      const trigger = item.querySelector('[data-foldout-trigger]');
      const content = item.querySelector('[data-foldout-content]');

      if (!trigger || !content) return;

      trigger.setAttribute('aria-expanded', 'true');
      content.setAttribute('aria-hidden', 'false');
      item.classList.add('foldout-item--open');

      // Set max-height for animation
      content.style.maxHeight = content.scrollHeight + 'px';
    }

    close(item) {
      const trigger = item.querySelector('[data-foldout-trigger]');
      const content = item.querySelector('[data-foldout-content]');

      if (!trigger || !content) return;

      trigger.setAttribute('aria-expanded', 'false');
      content.setAttribute('aria-hidden', 'true');
      item.classList.remove('foldout-item--open');

      // Reset max-height for animation
      content.style.maxHeight = '0';
    }

    connectedCallback() {
      // Reinitialize when section is reloaded in theme editor
      if (Shopify && Shopify.designMode) {
        this.init();
      }
    }
  }

  if (!customElements.get('foldout-component')) {
    customElements.define('foldout-component', FoldoutComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form-recommendation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('recommendationForm');

    // -------------------------------------------------------------------------
    // * Account Holder Toggle
    // -------------------------------------------------------------------------
    const toggleCheckbox = document.getElementById('account-holder-toggle');
    const hiddenSection = document.getElementById('section-account-holder');

    const accountInputs = hiddenSection ? hiddenSection.querySelectorAll('input') : [];

    function toggleSection() {
      if (toggleCheckbox.checked) {
        hiddenSection.classList.add('hidden');
        accountInputs.forEach((input) => input.removeAttribute('required'));
      } else {
        hiddenSection.classList.remove('hidden');
        accountInputs.forEach((input) => input.setAttribute('required', 'true'));
      }
    }

    if (toggleCheckbox && hiddenSection) {
      toggleSection();
      toggleCheckbox.addEventListener('change', toggleSection);
    }

    // -------------------------------------------------------------------------
    // * Product Selection
    // -------------------------------------------------------------------------
    const selectedProductsContainer = document.getElementById('selected-products-container');

    // Function to re-index hidden inputs so lineItems[0], lineItems[1] are sequential
    function reindexInputs() {
      const cards = selectedProductsContainer.querySelectorAll('.selected-product-card');
      cards.forEach((card, index) => {
        const inputs = card.querySelectorAll('input[name*="lineItems"]');
        inputs.forEach((input) => {
          const name = input.getAttribute('name');
          if (name) {
            input.setAttribute('name', name.replace(/lineItems\[\d+\]/, `lineItems[${index}]`));
          }
        });
      });
    }

    function addProductToForm(product) {
      const card = document.createElement('div');
      card.className = 'selected-product-card';

      const index = selectedProductsContainer.querySelectorAll('.selected-product-card').length;

      card.innerHTML = `
        <button type="button" class="remove-product-btn header-close" aria-label="Remove product">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 1L1 13M1 1L13 13" stroke="#1F2937" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
        <div class="selected-product-header">
          ${product.image ? `<img src="${product.image}" class="selected-product-img" />` : ''}
        </div>
        <div class="selected-product-details">
          <span class="selected-product-title ep-body ep-body--regular">${product.title}</span>
          <div class="selected-product-meta ep-body ep-body--caption">
            <span class="selected-product-brand">${product.vendor}</span>
            <span class="selected-product-price">${product.price}</span>
          </div>
        </div>

        <div class="selected-product-actions ep-body ep-body--caption">
          <span class="qty-label"># Products Sold in Office:</span>
          <div class="qty-control">
            <button type="button" class="qty-btn minus">&ndash;</button>
            <input type="number" name="lineItems[${index}][quantitySoldInOffice]" value="0" min="0" class="qty-input">
            <button type="button" class="qty-btn plus">+</button>
          </div>
          <button type="button" class="remove-product-btn footer-trash" aria-label="Remove product">
            <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 18C2.45 18 1.97917 17.8042 1.5875 17.4125C1.19583 17.0208 1 16.55 1 16V3H0V1H5V0H11V1H16V3H15V16C15 16.55 14.8042 17.0208 14.4125 17.4125C14.0208 17.8042 13.55 18 13 18H3ZM13 3H3V16H13V3ZM5 14H7V5H5V14ZM9 14H11V5H9V14Z" fill="#6B7280"/></svg>
          </button>
        </div>
        <input type="hidden" name="lineItems[${index}][variantId]" value="gid://shopify/ProductVariant/${product.variantId}">
      `;

      card.querySelectorAll('.remove-product-btn').forEach((btn) => {
        btn.addEventListener('click', function () {
          card.remove();
          reindexInputs();
        });
      });
      const qtyInput = card.querySelector('.qty-input');
      const minusBtn = card.querySelector('.qty-btn.minus');
      const plusBtn = card.querySelector('.qty-btn.plus');

      minusBtn.addEventListener('click', function () {
        let val = parseInt(qtyInput.value) || 0;
        if (val > 0) {
          qtyInput.value = val - 1;
        }
      });

      plusBtn.addEventListener('click', function () {
        let val = parseInt(qtyInput.value) || 0;
        qtyInput.value = val + 1;
      });

      selectedProductsContainer.appendChild(card);
    }

    document.addEventListener('recommendation:product-selected', function (e) {
      const product = e.detail;

      const existingInput = selectedProductsContainer.querySelector(`input[value="${product.variantId}"]`);
      if (existingInput) {
        // TODO: Add Better Error Handling
        alert('This product has already been added.');
        return;
      }

      addProductToForm(product);
    });

    // Function to clear all product cards and show the add button
    function clearProducts() {
      const productCards = selectedProductsContainer.querySelectorAll('.selected-product-card');
      productCards.forEach((card) => card.remove());

      const addBtnContainer = selectedProductsContainer.querySelector('.ep-leadgen__add_btn_container');
      if (addBtnContainer) {
        addBtnContainer.style.display = '';
      }
    }

    // -------------------------------------------------------------------------
    // * AJAX Form Submission
    // -------------------------------------------------------------------------
    const messageContainer = document.querySelector('#recommendation-form .form-messages');
    const submitButton = form?.querySelector('button[type="submit"]');

    if (form && submitButton) {
      form.addEventListener('submit', async function (e) {
        if (!form.checkValidity()) {
          return;
        }

        e.preventDefault();

        // Ensure at least one product is selected
        const productCards = selectedProductsContainer.querySelectorAll('.selected-product-card');
        if (productCards.length === 0) {
          // TODO: Add Better Error Handling
          alert('Please select at least one product.');
          return;
        }

        // Set Loading State
        submitButton.classList.add('loading');
        submitButton.disabled = true;

        // Hide previous messages
        messageContainer.textContent = '';
        messageContainer.className = 'form-messages';

        const formData = new FormData(form);

        try {
          const response = await fetch(window.location.href, {
            method: 'POST',
            body: formData,
            headers: { Accept: 'application/json' },
          });

          // Check For Response Type
          const contentType = response.headers.get('content-type');
          let result = {};

          if (contentType && contentType.indexOf('application/json') !== -1) {
            result = await response.json();
          } else {
            // If we got non-json response (e.g. 500 error page), throw a generic error
            throw new Error('An unexpected server error occurred. Please try again.');
          }

          if (response.ok && result.success) {
            form.reset();
            clearProducts();

            if (toggleCheckbox) {
              toggleCheckbox.checked = true;
              toggleSection();
            }

            document.getElementById('recommendation-form-no-email')?.syncFromForm?.();

            messageContainer.textContent = 'Recommendation submitted successfully!';
            messageContainer.classList.add('success');

            window.scrollTo({ top: 0, behavior: 'smooth' });
          } else {
            throw new Error(result.errorMessage || 'There was a problem submitting the form.');
          }
        } catch (error) {
          messageContainer.textContent = error.message;
          messageContainer.classList.add('error');
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } finally {
          submitButton.classList.remove('loading');
          submitButton.disabled = false;
        }
      });

      form.addEventListener('reset', function () {
        clearProducts();

        if (toggleCheckbox) {
          toggleCheckbox.checked = true;
          toggleSection();
        }

        messageContainer.textContent = '';
        messageContainer.className = 'form-messages';
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["help-tooltip"] && !Shopify.designMode) return;
  try {
    class HelpTooltip extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this.trigger = this.querySelector('[data-help-tooltip-trigger]');
      this.bubble = this.querySelector('[data-help-tooltip-bubble]');
      if (!this.trigger || !this.bubble) return;

      this.trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this._toggle();
      });
      this.addEventListener('mouseenter', () => this._open());
      this.addEventListener('mouseleave', () => {
        if (document.activeElement !== this.trigger) this._close();
      });
      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) this._close();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !this.bubble.hidden) {
          e.preventDefault();
          this._close();
          this.trigger.focus();
        }
      });

      this._ready = true;
    }

    _open() {
      this.bubble.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true');
      this.setAttribute('data-open', '');
    }

    _close() {
      this.bubble.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
      this.removeAttribute('data-open');
    }

    _toggle() {
      if (this.bubble.hidden) this._open();
      else this._close();
    }
  }

  if (!customElements.get('help-tooltip')) {
    customElements.define('help-tooltip', HelpTooltip);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["incrementer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const incrementers = document.querySelectorAll('.ep-incrementer');

    incrementers.forEach((incrementer) => {
      const minusButton = incrementer.querySelector('[data-action="decrement"]');
      const plusButton = incrementer.querySelector('[data-action="increment"]');
      const valueDisplay = incrementer.querySelector('.ep-incrementer__number');
      const hiddenInput = incrementer.querySelector('.ep-incrementer__input');

      if (!minusButton || !plusButton || !valueDisplay || !hiddenInput) return;

      // Read values dynamically from data attributes to support B2B quantity rule updates
      const getMinValue = () => parseInt(incrementer.dataset.min) || 1;
      const getMaxValue = () => parseInt(incrementer.dataset.max) || 99;
      const getStep = () => parseInt(incrementer.dataset.step) || 1;
      const getCurrentValue = () => parseInt(valueDisplay.textContent) || getMinValue();

      function updateValue(newValue) {
        const minValue = getMinValue();
        const maxValue = getMaxValue();
        const clampedValue = Math.max(minValue, Math.min(maxValue, newValue));

        valueDisplay.textContent = clampedValue;
        hiddenInput.value = clampedValue;

        // Update button states
        minusButton.disabled = clampedValue <= minValue;
        plusButton.disabled = clampedValue >= maxValue;
      }

      // Expose updateValue for external updates (B2B variant changes)
      incrementer._updateValue = updateValue;

      minusButton.addEventListener('click', () => {
        updateValue(getCurrentValue() - getStep());
      });

      plusButton.addEventListener('click', () => {
        updateValue(getCurrentValue() + getStep());
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["input-action"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    // Handle action button clicks
    const actionButtons = document.querySelectorAll('[data-input-action] .input-action__button');

    actionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        const wrapper = button.closest('[data-input-action]');
        const input = wrapper.querySelector('.input-action__input');

        // Apply action - validate and potentially change state
        // This would typically trigger form validation or API call
        console.log('Apply action triggered for:', input.value);
      });
    });

    // Handle remove button clicks (in success state)
    const removeButtons = document.querySelectorAll('[data-input-action] .input-action__remove');

    removeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        const wrapper = button.closest('[data-input-action]');
        const input = wrapper.querySelector('.input-action__input');

        // Clear input and reset state
        input.value = '';
        wrapper.classList.remove('input-action--valid');
        wrapper.classList.add('input-action--default');
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["navigation-component"] && !Shopify.designMode) return;
  try {
    class NavigationComponent extends HTMLElement {
    constructor() {
      super();
      try {
        this.init();
      } catch (e) {
        console.error('NavigationComponent init error:', e);
      }
    }

    // Helper method to ensure elements are found (defensive programming)
    ensureElements() {
      if (!this.mobileToggle) {
        this.mobileToggle = this.querySelector('.ep-navigation__mobile-toggle');
      }
      if (!this.mobileMenu) {
        this.mobileMenu = document.querySelector('.ep-navigation__mobile-menu');
      }
      if (!this.mobileBackdrop) {
        this.mobileBackdrop = document.querySelector('.ep-navigation__mobile-backdrop');
      }
      return !!(this.mobileToggle && this.mobileMenu);
    }

    init() {
      this.dropdownToggles = this.querySelectorAll('.ep-navigation__dropdown-toggle');
      this.dropdownItems = this.querySelectorAll('.ep-navigation__dropdown-item, .ep-navigation__dropdown-button');
      this.mobileToggle = this.querySelector('.ep-navigation__mobile-toggle');

      // Find mobile menu - use document.querySelector as primary method since nextElementSibling can be unreliable
      // due to whitespace/comment nodes between elements
      this.mobileMenu = document.querySelector('.ep-navigation__mobile-menu');
      // Fallback to nextElementSibling if querySelector didn't find it
      if (!this.mobileMenu) {
        let sibling = this.nextElementSibling;
        // Skip comment nodes and find the actual element
        while (sibling && (sibling.nodeType !== 1 || !sibling.classList?.contains('ep-navigation__mobile-menu'))) {
          sibling = sibling.nextElementSibling;
        }
        this.mobileMenu = sibling;
      }
      this.mobileMenuLinks = this.mobileMenu
        ? this.mobileMenu.querySelectorAll('.ep-navigation__mobile-dropdown-item')
        : [];

      this.lastScrollY = 0;
      this.scrollThreshold = 10;
      this.scrollUpCount = 0;
      this.scrollDownCount = 0;
      this.isHidden = false;
      this.isTransparent = this.classList.contains('ep-navigation--transparent');

      this.handleDropdownChange = this.handleDropdownChange.bind(this);
      this.handleDropdownItemClick = this.handleDropdownItemClick.bind(this);
      this.handleOutsideClick = this.handleOutsideClick.bind(this);
      this.handleEscapeKey = this.handleEscapeKey.bind(this);
      this.handleMobileToggle = this.handleMobileToggle.bind(this);
      this.handleMobileLinkClick = this.handleMobileLinkClick.bind(this);
      this.handleScroll = this.handleScroll.bind(this);

      this.setupDropdownListeners();
      this.setupMobileMenuListeners();
      this.setupGlobalListeners();
      this.setupScrollListener();
    }

    // ============================================
    // DESKTOP DROPDOWN FUNCTIONALITY
    // ============================================

    setupDropdownListeners() {
      this.dropdownToggles.forEach((toggle) => {
        toggle.addEventListener('change', this.handleDropdownChange);
      });

      this.dropdownItems.forEach((item) => {
        item.addEventListener('click', this.handleDropdownItemClick);
      });
    }

    handleDropdownChange(event) {
      if (event.target.checked) {
        this.closeOtherDropdowns(event.target);
        this.classList.remove('ep-navigation--hidden');
        this.isHidden = false;
      }
    }

    closeOtherDropdowns(exceptToggle) {
      this.dropdownToggles.forEach((toggle) => {
        if (toggle !== exceptToggle) {
          toggle.checked = false;
        }
      });
    }

    handleDropdownItemClick(event) {
      const dropdown = event.target.closest('.ep-navigation__dropdown');
      if (dropdown) {
        const dropdownHandle = dropdown.getAttribute('data-dropdown');
        const toggle = this.querySelector(`#dropdown-${dropdownHandle}`);
        if (toggle) {
          toggle.checked = false;
        }
      }
    }

    closeAllDropdowns() {
      this.dropdownToggles.forEach((toggle) => {
        toggle.checked = false;
      });
    }

    // ============================================
    // MOBILE MENU FUNCTIONALITY
    // ============================================

    setupMobileMenuListeners() {
      // Ensure elements exist before setting up listeners
      if (!this.ensureElements()) {
        // Retry after a short delay in case DOM isn't ready
        setTimeout(() => {
          if (this.ensureElements()) {
            this.setupMobileMenuListeners();
          }
        }, 100);
        return;
      }

      // Remove existing listener to prevent duplicates
      if (this.mobileToggleClickHandler) {
        this.mobileToggle.removeEventListener('click', this.mobileToggleClickHandler);
      }

      // Create click handler for mobile toggle
      this.mobileToggleClickHandler = (e) => {
        this.handleMobileToggle(e);
      };
      this.mobileToggle.addEventListener('click', this.mobileToggleClickHandler);

      // Close menu when clicking outside the menu content (on the backdrop/empty area)
      if (this.mobileMenuClickHandler) {
        this.mobileMenu.removeEventListener('click', this.mobileMenuClickHandler);
      }
      this.mobileMenuClickHandler = (e) => {
        // Close if clicking directly on the mobile menu container (not on its children)
        if (e.target === this.mobileMenu) {
          this.closeMobileMenu();
        }
      };
      this.mobileMenu.addEventListener('click', this.mobileMenuClickHandler);

      // Also close when clicking on the search area if it's empty space
      const mobileSearch = this.mobileMenu.querySelector('.ep-navigation__mobile-search');
      if (mobileSearch) {
        if (this.mobileSearchClickHandler) {
          mobileSearch.removeEventListener('click', this.mobileSearchClickHandler);
        }
        this.mobileSearchClickHandler = (e) => {
          // Only close if clicking on the search container itself, not the input
          if (e.target === mobileSearch) {
            this.closeMobileMenu();
          }
        };
        mobileSearch.addEventListener('click', this.mobileSearchClickHandler);
      }

      this.mobileMenuLinks.forEach((link) => {
        link.addEventListener('click', this.handleMobileLinkClick);
      });

      // Close menu when clicking on the backdrop
      if (this.mobileBackdrop) {
        if (this.mobileBackdropClickHandler) {
          this.mobileBackdrop.removeEventListener('click', this.mobileBackdropClickHandler);
        }
        this.mobileBackdropClickHandler = () => {
          this.closeMobileMenu();
        };
        this.mobileBackdrop.addEventListener('click', this.mobileBackdropClickHandler);
      }
    }

    handleMobileToggle() {
      // Ensure elements exist before handling toggle
      if (!this.ensureElements()) {
        return;
      }

      const isOpen = this.classList.toggle('mobile-menu-open');
      this.mobileToggle.setAttribute('aria-expanded', isOpen.toString());

      // Prevent body scroll - iOS Safari compatible
      if (isOpen) {
        // Store scroll position for iOS
        const scrollY = window.scrollY;
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        document.body.style.top = `-${scrollY}px`;
        // Store scroll position for restoration
        this.scrollY = scrollY;

        // Prevent touchmove on iOS (allow scrolling inside menu)
        this.touchMoveHandler = (e) => {
          if (this.mobileMenu && !this.mobileMenu.contains(e.target)) {
            e.preventDefault();
          }
        };
        document.addEventListener('touchmove', this.touchMoveHandler, { passive: false });

        this.classList.remove('ep-navigation--hidden');
        this.isHidden = false;
        // Direct style manipulation as fallback if CSS selector isn't working
        if (this.mobileMenu) {
          this.mobileMenu.style.opacity = '1';
          this.mobileMenu.style.visibility = 'visible';
        }
      } else {
        // Restore scroll position for iOS
        const scrollY = this.scrollY || 0;
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.top = '';
        this.scrollY = null;

        // Remove touchmove listener
        if (this.touchMoveHandler) {
          document.removeEventListener('touchmove', this.touchMoveHandler);
          this.touchMoveHandler = null;
        }

        if (this.mobileMenu) {
          this.mobileMenu.style.opacity = '';
          this.mobileMenu.style.visibility = '';
        }
        window.scrollTo(0, parseInt(scrollY));
      }
    }

    handleMobileLinkClick() {
      this.closeMobileMenu();
    }

    closeMobileMenu() {
      this.classList.remove('mobile-menu-open');

      // Restore scroll position for iOS
      const scrollY = this.scrollY || 0;
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.top = '';
      this.scrollY = null;

      // Remove touchmove listener
      if (this.touchMoveHandler) {
        document.removeEventListener('touchmove', this.touchMoveHandler);
        this.touchMoveHandler = null;
      }

      if (this.mobileToggle) {
        this.mobileToggle.setAttribute('aria-expanded', 'false');
      }
      if (this.mobileMenu) {
        this.mobileMenu.style.opacity = '';
        this.mobileMenu.style.visibility = '';
      }
      window.scrollTo(0, parseInt(scrollY));
    }

    // ============================================
    // GLOBAL EVENT LISTENERS
    // ============================================

    setupGlobalListeners() {
      // Close dropdowns when clicking outside
      document.addEventListener('click', this.handleOutsideClick);

      // Close dropdowns and mobile menu on Escape key
      document.addEventListener('keydown', this.handleEscapeKey);
    }

    // ============================================
    // SCROLL-BASED BEHAVIOR
    // ============================================

    setupScrollListener() {
      // Remove existing scroll listener if present
      if (this.scrollHandler) {
        window.removeEventListener('scroll', this.scrollHandler);
        this.scrollHandler = null;
      }

      // Initialize scroll position
      this.lastScrollY = window.scrollY || window.pageYOffset;

      // Add scroll listener if navigation is sticky
      if (this.classList.contains('ep-navigation--sticky')) {
        // Check initial scroll position
        this.handleScroll();

        // Throttle scroll events for performance
        let ticking = false;
        const scrollHandler = () => {
          if (!ticking) {
            window.requestAnimationFrame(() => {
              this.handleScroll();
              ticking = false;
            });
            ticking = true;
          }
        };

        window.addEventListener('scroll', scrollHandler, { passive: true });
        this.scrollHandler = scrollHandler;
      } else {
        // Remove scroll-related classes if no longer sticky
        this.classList.remove('ep-navigation--scrolled');
        this.classList.remove('ep-navigation--hidden');
        this.isHidden = false;
      }
    }

    // Helper to check mobile menu state without allocations
    isMobileMenuOpen() {
      return this.classList.contains('mobile-menu-open');
    }

    // Helper to check dropdown state without Array.from allocation
    hasOpenDropdown() {
      for (let i = 0; i < this.dropdownToggles.length; i++) {
        if (this.dropdownToggles[i].checked) return true;
      }
      return false;
    }

    handleScroll() {
      const scrollY = window.scrollY;
      const scrollDelta = scrollY - this.lastScrollY;

      // Skip sub-pixel / no-op movements
      if (Math.abs(scrollDelta) < 1) return;

      // Always show nav at the top of the page (use <= 0 for rubber-band scroll on touch devices)
      if (scrollY <= 0) {
        if (this.isHidden) {
          this.classList.remove('ep-navigation--hidden');
          this.isHidden = false;
        }
        this.classList.remove('ep-navigation--scrolled');
        this.lastScrollY = scrollY;
        this.scrollUpCount = 0;
        this.scrollDownCount = 0;
        return;
      }

      // Handle transparency scrolled state (for transparent + sticky navs)
      if (this.isTransparent) {
        this.classList.toggle('ep-navigation--scrolled', scrollY > 0);
      }

      // Handle hide/show behavior for sticky navs
      // Don't hide if mobile menu or dropdowns are open
      if (!this.isMobileMenuOpen() && !this.hasOpenDropdown()) {
        if (scrollDelta > this.scrollThreshold) {
          // Scrolling down - require 2 consecutive frames before hiding
          this.scrollUpCount = 0;
          this.scrollDownCount++;
          if (this.scrollDownCount >= 2 && !this.isHidden) {
            this.classList.add('ep-navigation--hidden');
            this.isHidden = true;
          }
        } else if (scrollDelta < -this.scrollThreshold) {
          // Scrolling up - require 2 consecutive frames before showing
          this.scrollDownCount = 0;
          this.scrollUpCount++;
          if (this.scrollUpCount >= 2 && this.isHidden) {
            this.classList.remove('ep-navigation--hidden');
            this.isHidden = false;
          }
        }
      }

      // Update last scroll position
      this.lastScrollY = scrollY;
    }

    handleOutsideClick(event) {
      const isInsideDropdown = event.target.closest('.ep-navigation__link-wrapper--dropdown');
      const isDropdownItem = event.target.closest('.ep-navigation__dropdown');

      if (!isInsideDropdown && !isDropdownItem) {
        this.closeAllDropdowns();
      }
    }

    handleEscapeKey(event) {
      if (event.key === 'Escape') {
        this.closeAllDropdowns();

        // Also close mobile menu if it's open
        if (this.classList.contains('mobile-menu-open')) {
          this.closeMobileMenu();
        }
      }
    }

    // ============================================
    // LIFECYCLE METHODS
    // ============================================

    connectedCallback() {
      // Reinitialize when section is reloaded in theme editor
      if (Shopify && Shopify.designMode) {
        this.init();
      } else {
        // Use a small delay to ensure DOM is fully ready (mobile menu might be rendered after component)
        setTimeout(() => {
          // Re-check for elements and setup listeners if needed
          if (this.ensureElements() && !this.mobileToggleClickHandler) {
            this.setupMobileMenuListeners();
          }
          // Re-check scroll listener setup in case transparent class was added dynamically
          this.setupScrollListener();
        }, 100);
      }
    }

    disconnectedCallback() {
      // Clean up global event listeners
      document.removeEventListener('click', this.handleOutsideClick);
      document.removeEventListener('keydown', this.handleEscapeKey);

      // Clean up scroll listener
      if (this.scrollHandler) {
        window.removeEventListener('scroll', this.scrollHandler);
      }

      // Clean up touchmove listener if menu is still open
      if (this.touchMoveHandler) {
        document.removeEventListener('touchmove', this.touchMoveHandler);
        this.touchMoveHandler = null;
      }
    }
  }

  if (!customElements.get('navigation-component')) {
    try {
      customElements.define('navigation-component', NavigationComponent);
    } catch (e) {
      console.error('Error defining navigation-component:', e);
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["patient-database-table"] && !Shopify.designMode) return;
  try {
    class InspectableTable extends HTMLElement {
    constructor() {
      super();
      this.rowClickHandler = this.rowClickHandler.bind(this);
      this.handleSearchInput = this.handleSearchInput.bind(this);
      this.handleSearchFocus = this.handleSearchFocus.bind(this);
      this.cache = new Map();
      this.debounceTimer = null;
    }

    connectedCallback() {
      this.table = this.querySelector('table');
      const table = this.table;
      if (!this.table) return;

      // Row click handlers
      table.querySelectorAll('tbody tr').forEach((row) => {
        row.addEventListener('click', this.rowClickHandler);
      });

      // Search input inside this component
      this.searchInput = this.querySelector('.patient-database-table-header input[type="search"]');

      if (this.searchInput) {
        this.createSearchResultsContainer();
        this.searchInput.addEventListener('focus', this.handleSearchFocus);
        this.searchInput.addEventListener('input', this.handleSearchInput);
      }
    }

    disconnectedCallback() {
      if (!this.table) return;
      this.table.querySelectorAll('tbody tr').forEach((row) => {
        row.removeEventListener('click', this.rowClickHandler);
      });

      if (this.searchInput) {
        this.searchInput.removeEventListener('focus', this.handleSearchFocus);
        this.searchInput.removeEventListener('input', this.handleSearchInput);
      }
    }

    /* ---------------- ROW CLICK ---------------- */
    async rowClickHandler(event) {
      if (!this.table) return;
      const row = event.currentTarget;
      const table = this.table;
      row.classList.toggle('selected');

      table.querySelectorAll('tbody tr').forEach((r) => {
        if (r !== row) {
          r.classList.remove('selected');
        }
      });

      // first remove any existing order history rows
      const existingRow = table.querySelector('.order-history-container');
      if (existingRow) {
        existingRow.remove();
      }

      if (!row.classList.contains('selected')) return;

      const patientId = row.dataset.patientId;
      const productLookup = row.dataset.productLookup;

      if (!patientId) return;

      const detailsRow = document.createElement('tr');
      detailsRow.className = 'order-history-container';

      const detailsCell = document.createElement('td');
      detailsCell.colSpan = row.children.length;
      detailsCell.className = 'order-history-cell';
      detailsCell.innerHTML = '<p>Loading order history…</p>';

      detailsRow.appendChild(detailsCell);
      row.parentNode.insertBefore(detailsRow, row.nextSibling);

      try {
        let orders;

        // Cache per patient
        if (this.cache.has(patientId)) {
          orders = this.cache.get(patientId);
        } else {
          const response = await fetch(`/apps/portal/api/patients/${patientId}/subscriptions`);

          if (!response.ok) {
            // TODO: Actual Error Implement
            throw new Error('Failed to fetch order history');
          }

          const data = await response.json();
          orders = data?.data?.subscriptions || [];
          this.cache.set(patientId, orders);
        }

        if (!orders.length) {
          // TODO: Actual HTML Implement
          detailsCell.innerHTML = '<p>No order history found.</p>';
          return;
        }

        detailsCell.innerHTML = this.renderOrderHistoryTable(orders);
      } catch (err) {
        console.error(err);
        // TODO: Actual HTML Implement
        detailsCell.innerHTML = '<p class="error">Unable to load order history.</p>';
      }
    }

    renderOrderHistoryTable(orders) {
      let html = `
        <table class="order-history-table">
          <thead>
            <tr>
              <th>Start Date</th>
              <th>Product</th>
              <th>Subscription Status</th>
              <th>Last Order Date</th>
              <th>Next Order Date</th>
            </tr>
          </thead>
          <tbody>
      `;

      orders.forEach((order) => {
        html += `
          <tr>
            <td>${order.date || 'N/A'}</td>
            <td>
              ${
                order.productUrl
                  ? `<a href="${order.productUrl}" target="_blank">${order.product}</a>`
                  : order.product || 'N/A'
              }
            </td>
            <td>${order.status || 'N/A'}</td>
            <td>${order.lastOrderDate || 'N/A'}</td>
            <td>${order.nextOrderDate || 'N/A'}</td>
          </tr>
        `;
      });

      html += '</tbody></table>';
      return html;
    }

    /* ---------------- SEARCH ---------------- */
    async fetchPatients(searchTerm = '') {
      if (!searchTerm || searchTerm.length < 3) {
        this.clearSearchResults();
        return;
      }

      try {
        const res = await fetch(`/apps/portal/api/search-patients?name=${encodeURIComponent(searchTerm)}`);
        if (!res.ok) throw new Error('API error');

        const data = await res.json();

        this.renderSearchResults(data?.data || []);
      } catch (err) {
        console.error('Patients API failed:', err);
        this.clearSearchResults();
      }
    }

    handleSearchFocus() {
      this.fetchPatients();
    }

    handleSearchInput(e) {
      const value = e.target.value.trim();

      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.fetchPatients(value);
      }, 300);
    }

    createSearchResultsContainer() {
      if (!this.searchInput) return;

      const container = this.searchInput.closest('.search__container');
      if (!container) return;

      this.resultsList = document.createElement('ul');
      this.resultsList.className = 'patient-search-results';

      container.appendChild(this.resultsList);
    }

    clearSearchResults() {
      if (this.resultsList) {
        this.resultsList.innerHTML = '';
      }
    }

    renderSearchResults(customers = []) {
      if (!this.resultsList) return;

      this.clearSearchResults();

      customers.forEach((customer) => {
        const li = document.createElement('li');
        li.textContent = customer.name;
        li.dataset.patientSearchId = customer.id;

        li.addEventListener('click', () => {
          const url = new URL(window.location.href);
          url.searchParams.set('patient', customer.id);
          window.location.href = url.toString();
        });

        this.resultsList.appendChild(li);
      });
    }
  }

  if (!customElements.get('table-inspectable')) {
    customElements.define('table-inspectable', InspectableTable);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["patient-orders-table"] && !Shopify.designMode) return;
  try {
    class OrderVisualizerTable extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.table = this.querySelector('table.patient-orders-table');
      const table = this.table;
      if (!this.table) return;

      const max_value = parseInt(table.getAttribute('data-max-value'));

      table.querySelectorAll('tbody tr').forEach((row, index) => {
        // read and parse the JSON in the data-attribute of this row
        const data = JSON.parse(row.getAttribute('data-orders'));

        // generate markup in the td.visualization based on the data
        if (data == undefined) return;
        const visualizationCell = row.querySelector('td.visualization');
        if (!visualizationCell) return;

        const totalOrders = data.total || 0;
        const firstOrders = data.firstOrders || 0;
        const refillOrders = data.refillOrders || 0;
        const firstOrdersPercent = totalOrders > 0 ? (firstOrders / totalOrders) * 100 : 0;
        const refillOrdersPercent = totalOrders > 0 ? (refillOrders / totalOrders) * 100 : 0;
        const relativeSize = (data.total / max_value) * 100;

        visualizationCell.innerHTML = `
          <div class="visualization-wrapper" style="--max-width: ${relativeSize}%; --index: ${index}">
            <div class="visualization-bar">
              ${
                firstOrdersPercent == 0
                  ? ''
                  : `<div class="first-orders" style="width: ${firstOrdersPercent}%;" title="First orders: ${data.firstOrders}"></div>`
              }
              ${
                refillOrdersPercent == 0
                  ? ''
                  : `<div class="refill-orders" style="width: ${refillOrdersPercent}%;" title="Refills: ${data.refillOrders}"></div>`
              }
            </div>
            <div class="label">${totalOrders}</div>
          </div>
        `;
      });
    }
  }

  customElements.define('order-visualizer-table', OrderVisualizerTable);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["portal-cash-out-table"] && !Shopify.designMode) return;
  try {
    class CashOutTable extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      // Cache DOM references
      this.list = this.querySelector('[data-cash-out-list]');
      this.displayTotal = this.querySelector('[data-display-total]');
      this.transactionIdsInput = this.querySelector('[data-transaction-ids]');
      this.totalAmountInput = this.querySelector('[data-total-amount]');
      this.submitBtn = this.querySelector('[data-submit-btn]');
      this.lowFundsError = this.querySelector('[data-low-funds-error]');

      if (!this.list) return;

      // Bind methods
      this.updateTotal = this.updateTotal.bind(this);
      this.handleCheckboxChange = this.handleCheckboxChange.bind(this);

      // Listen for checkbox changes using event delegation
      this.list.addEventListener('change', this.handleCheckboxChange);

      // Initial calculation
      this.updateTotal();
    }

    handleCheckboxChange(event) {
      if (event.target.matches('[data-cash-out-checkbox]')) {
        this.updateTotal();
      }
    }

    updateTotal() {
      const checkboxes = this.querySelectorAll('[data-cash-out-checkbox]:checked');
      let total = 0;
      let allIds = [];

      checkboxes.forEach((box) => {
        const amount = parseFloat(box.getAttribute('data-amount'));
        if (!isNaN(amount)) {
          total += amount;
        }

        try {
          // Handle single-quoted JSON from Liquid template
          const idsAttr = box.getAttribute('data-ids').replace(/'/g, '"');
          const ids = JSON.parse(idsAttr);
          if (Array.isArray(ids)) {
            allIds = allIds.concat(ids);
          }
        } catch (e) {
          console.error('Error parsing IDs for checkbox', e);
        }
      });

      const formattedTotal = '$' + total.toFixed(2);

      console.log('Cash Out Update:', { total, formattedTotal, allIds });

      // Update display
      if (this.displayTotal) {
        this.displayTotal.textContent = formattedTotal;
      }

      // Update hidden inputs
      if (this.transactionIdsInput) {
        this.transactionIdsInput.value = JSON.stringify(allIds);
      }

      if (this.totalAmountInput) {
        this.totalAmountInput.value = formattedTotal;
      }

      // Update submit button and error state
      if (this.submitBtn && this.lowFundsError) {
        if (total > 50) {
          this.submitBtn.disabled = false;
          this.lowFundsError.style.display = 'none';
        } else {
          this.submitBtn.disabled = true;
          this.lowFundsError.style.display = total > 0 ? 'block' : 'none';
        }
      }
    }

    connectedCallback() {
      // Reinitialize when section is reloaded in theme editor
      if (Shopify && Shopify.designMode) {
        this.init();
      }
    }

    disconnectedCallback() {
      // Clean up event listener
      if (this.list) {
        this.list.removeEventListener('change', this.handleCheckboxChange);
      }
    }
  }

  if (!customElements.get('cash-out-table')) {
    customElements.define('cash-out-table', CashOutTable);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-image-carousel"] && !Shopify.designMode) return;
  try {
    class ProductCarousel extends HTMLElement {
    constructor() {
      super();
      this.images = this.querySelector('[data-carousel-images]');
      this.prevBtn = this.querySelector('[data-carousel-prev]');
      this.nextBtn = this.querySelector('[data-carousel-next]');
      this.thumbnails = this.querySelectorAll('[data-thumbnail-index]');
      this.dots = this.querySelectorAll('[data-dot-index]');
      this.imageElements = this.querySelectorAll('[data-image-index]');
      this.currentIndex = 0;

      if (!this.images) return;

      this.images.addEventListener(
        'scrollend',
        () => {
          this.currentIndex = this.calculateCurrentIndex();
          this.updateUI();
        },
        { passive: true },
      );

      this.prevBtn?.addEventListener('click', () => this.navigate(-1));
      this.nextBtn?.addEventListener('click', () => this.navigate(1));

      this.thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {
          this.scrollToImage(parseInt(thumbnail.dataset.thumbnailIndex, 10));
        });
      });

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.scrollToImage(parseInt(dot.dataset.dotIndex, 10));
        });
      });

      this.updateHeight = this.updateHeight.bind(this);
      window.addEventListener('resize', this.updateHeight);

      this.waitForImages().then(() => {
        this.updateHeight();
        this.updateUI();
      });
    }

    navigate(direction) {
      const newIndex = this.currentIndex + direction;
      if (newIndex >= 0 && newIndex < this.imageElements.length) {
        this.scrollToImage(newIndex);
      }
    }

    calculateCurrentIndex() {
      if (!this.images || this.imageElements.length === 0) return 0;
      const scrollCenter = this.images.scrollLeft + this.images.clientWidth / 2;
      let closestIndex = 0;
      let closestDistance = Infinity;
      this.imageElements.forEach((el, i) => {
        const distance = Math.abs(scrollCenter - (el.offsetLeft + el.offsetWidth / 2));
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      });
      return closestIndex;
    }

    waitForImages() {
      const images = this.querySelectorAll('[data-image-index] img');
      const promises = Array.from(images).map((img) => {
        if (img.complete) return Promise.resolve();
        return new Promise((resolve) => {
          img.addEventListener('load', resolve, { once: true });
          img.addEventListener('error', resolve, { once: true });
        });
      });
      return Promise.all(promises);
    }

    updateUI() {
      this.prevBtn?.classList.toggle('disabled', this.currentIndex === 0);
      this.nextBtn?.classList.toggle('disabled', this.currentIndex === this.imageElements.length - 1);
      this.thumbnails.forEach((thumb, i) => {
        thumb.classList.toggle('product-image-carousel__thumbnail--active', i === this.currentIndex);
      });
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === this.currentIndex);
      });
      this.updateHeight();
    }

    updateHeight() {
      const img = this.imageElements[this.currentIndex]?.querySelector('img');
      if (img?.offsetHeight > 0) {
        this.images.style.height = `${img.offsetHeight}px`;
      }
    }

    scrollToImage(index) {
      const target = this.imageElements[index];
      if (target) {
        this.images.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.updateHeight);
    }
  }

  if (!customElements.get('product-carousel')) {
    customElements.define('product-carousel', ProductCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["table-pagination"] && !Shopify.designMode) return;
  try {
    class TablePagination extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.totalPages = parseInt(this.getAttribute('data-total-pages')) || 1;
      this.perPage = parseInt(this.getAttribute('data-per-page')) || 10;
      this.currentPage = 1;

      this.numbersContainer = this.querySelector('.pagination__numbers-list');
      this.prevBtn = this.querySelector('[data-pagination-prev]');
      this.nextBtn = this.querySelector('[data-pagination-next]');

      if (!this.numbersContainer || !this.prevBtn || !this.nextBtn) return;

      this.addListeners();
    }

    addListeners() {
      this.prevBtn.addEventListener('click', () => {
        if (this.currentPage > 1) this.goToPage(this.currentPage - 1);
      });

      this.nextBtn.addEventListener('click', () => {
        if (this.currentPage < this.totalPages) this.goToPage(this.currentPage + 1);
      });

      this.numbersContainer.addEventListener('click', (e) => {
        const target = e.target;

        if (target.matches('[data-pagination-page]')) {
          const page = parseInt(target.getAttribute('data-pagination-page'));
          if (page !== this.currentPage) this.goToPage(page);
        }

        if (target.closest('.js-ellipsis-forward')) {
          let newPage = this.currentPage + 3;
          if (newPage > this.totalPages) newPage = this.totalPages;
          this.goToPage(newPage);
        }

        if (target.closest('.js-ellipsis-back')) {
          let newPage = this.currentPage - 3;
          if (newPage < 1) newPage = 1;
          this.goToPage(newPage);
        }
      });
    }

    goToPage(page) {
      this.currentPage = page;
      this.updateUI();
    }

    updateUI() {
      this.prevBtn.classList.toggle('pagination--hidden', this.currentPage === 1);
      this.nextBtn.classList.toggle('pagination--hidden', this.currentPage === this.totalPages);
      this.renderPageNumbers();
      this.updateTableRows();
    }

    updateTableRows() {
      const rows = document.querySelectorAll('.js-data-row');

      rows.forEach((row, index) => {
        const start = (this.currentPage - 1) * this.perPage;
        const end = start + this.perPage;

        if (index >= start && index < end) {
          row.classList.remove('row-hidden');
        } else {
          row.classList.add('row-hidden');
        }
      });
    }

    renderPageNumbers() {
      let html = '';

      const createBtn = (pageNum, isActive) => `
        <button 
          class="pagination__btn ep-body ${isActive ? 'pagination__btn--active' : ''}" 
          data-pagination-page="${pageNum}"
          aria-label="Page ${pageNum}"
        >
          ${pageNum}
        </button>
      `;

      const createEllipsis = (direction) => `
        <button class="pagination__btn ep-body js-ellipsis-${direction}">...</button>
      `;

      if (this.totalPages <= 4) {
        for (let i = 1; i <= this.totalPages; i++) {
          html += createBtn(i, i === this.currentPage);
        }
      } else {
        if (this.currentPage <= 2) {
          for (let i = 1; i <= 3; i++) {
            html += createBtn(i, i === this.currentPage);
          }
          html += createEllipsis('forward');
          html += createBtn(this.totalPages, false);
        } else if (this.currentPage >= this.totalPages - 1) {
          html += createBtn(1, false);
          html += createEllipsis('back');
          for (let i = this.totalPages - 2; i <= this.totalPages; i++) {
            html += createBtn(i, i === this.currentPage);
          }
        } else {
          html += createBtn(1, false);
          html += createEllipsis('back');
          html += createBtn(this.currentPage - 1, false);
          html += createBtn(this.currentPage, true);
          html += createBtn(this.currentPage + 1, false);
          html += createEllipsis('forward');
          html += createBtn(this.totalPages, false);
        }
      }
      this.numbersContainer.innerHTML = html;
    }
  }

  customElements.define('table-pagination', TablePagination);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["testimonial-media-video-card"] && !Shopify.designMode) return;
  try {
    class TestimonialVideoCard extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.video = this.querySelector('video');
      this.playButton = this.querySelector('.testimonial-media-card__play-button');
      this.pauseButton = this.querySelector('.testimonial-media-card__pause-button');

      if (!this.video || !this.playButton || !this.pauseButton) return;

      // Bind methods
      this.handlePlay = this.handlePlay.bind(this);
      this.handlePause = this.handlePause.bind(this);
      this.handleVideoClick = this.handleVideoClick.bind(this);

      // Add event listeners
      this.playButton.addEventListener('click', this.handlePlay);
      this.pauseButton.addEventListener('click', this.handlePause);
      this.video.addEventListener('click', this.handleVideoClick);
    }

    handlePlay() {
      if (!this.video) return;

      this.video
        .play()
        .then(() => {
          this.playButton.style.display = 'none';
          this.pauseButton.style.display = 'block';
        })
        .catch((error) => {
          console.log('Video play failed:', error);
        });
    }

    handlePause() {
      if (!this.video) return;

      this.video.pause();
      this.pauseButton.style.display = 'none';
      this.playButton.style.display = 'block';
    }

    handleVideoClick() {
      if (!this.video) return;

      if (this.video.paused) {
        this.handlePlay();
      } else {
        this.handlePause();
      }
    }

    connectedCallback() {
      // Reinitialize when section is reloaded in theme editor
      if (Shopify && Shopify.designMode) {
        this.init();
      }
    }
  }

  if (!customElements.get('testimonial-video-card')) {
    customElements.define('testimonial-video-card', TestimonialVideoCard);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["text-area"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    // Handle character counting for textareas
    const textareas = document.querySelectorAll('.text-area__input');

    textareas.forEach(function (textarea) {
      const textareaWrapper = textarea.closest('.text-area');
      const characterCountElement = textareaWrapper.querySelector('.text-area__current-count');
      const characterCountContainer = textareaWrapper.querySelector('.text-area__character-count');

      if (characterCountElement && characterCountContainer) {
        const maxLength = parseInt(textarea.getAttribute('maxlength'));

        // Show/hide counter and update count on input
        textarea.addEventListener('input', function () {
          const currentLength = this.value.length;
          characterCountElement.textContent = currentLength;

          // Show counter when user starts typing, hide when empty
          if (currentLength > 0) {
            characterCountContainer.classList.remove('text-area__character-count--hidden');
          } else {
            characterCountContainer.classList.add('text-area__character-count--hidden');
          }

          // Add warning class if approaching limit
          if (currentLength >= maxLength * 0.9) {
            textareaWrapper.classList.add('text-area--approaching-limit');
          } else {
            textareaWrapper.classList.remove('text-area--approaching-limit');
          }

          if (currentLength >= maxLength) {
            textareaWrapper.classList.add('text-area--at-limit');
          } else {
            textareaWrapper.classList.remove('text-area--at-limit');
          }
        });

        // Initialize count and visibility
        const initialLength = textarea.value.length;
        characterCountElement.textContent = initialLength;

        if (initialLength > 0) {
          characterCountContainer.classList.remove('text-area__character-count--hidden');
        } else {
          characterCountContainer.classList.add('text-area__character-count--hidden');
        }
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-options"] && !Shopify.designMode) return;
  try {
    const variantInput = document.querySelector('[data-variant-input]') || document.querySelector('input[name="id"]');
  const variantLabel = document.querySelector('[data-size-label]');
  const variantOptions = document.querySelectorAll('[data-variant-option]');
  window.recommended_text = document.querySelector('[name="recommended_text"]').value;
  //window.variantData = JSON.parse(document.querySelector('.product [type="application/json"]').textContent);
  window.variantData = JSON.parse(document.querySelector('[data-product-variants]').textContent);

  const dynamicPriceContainer = document.querySelector('[data-dynamic-main-price]');
  const currentPriceEl = dynamicPriceContainer?.querySelector('.product__main-price-current');
  const comparePriceEl = dynamicPriceContainer?.querySelector('.product__main-price-compare');
  const sellingPlanData = JSON.parse(document.querySelector('[data-variant-selling-plan-prices]')?.textContent || '{}');


  // Format money helper
const formatMoney = (cents) => {
  return '$' + (cents / 100).toFixed(2);
};
// Function to update the main price display
const updateMainPriceDisplay = () => {
  if (!window.currentVariant || !currentPriceEl) return;
  
  const variantId = window.currentVariant.id;
  const priceData = sellingPlanData[variantId];
  if (!priceData) return;
  // We check if there's a hidden input for selling_plan with a value, or if a recharge radio button indicates subscription
  // Recharge commonly updates an input name="selling_plan" or we can check checked radio buttons
  const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
  const hasActiveSellingPlan = sellingPlanInput && sellingPlanInput.value && sellingPlanInput.value !== '';
  
  let finalPrice = priceData.price;
  let finalCompare = priceData.compare_at_price;
  if (hasActiveSellingPlan && priceData.subscription_price !== null) {
    finalPrice = priceData.subscription_price;
    finalCompare = priceData.subscription_compare;
  }
  // Update DOM
  currentPriceEl.textContent = formatMoney(finalPrice);
  
  if (finalCompare > finalPrice) {
    comparePriceEl.textContent = formatMoney(finalCompare);
    comparePriceEl.style.display = 'inline-block';
  } else {
    comparePriceEl.style.display = 'none';
  }
};


  const updateSelectedVariant = (optionEl) => {
    const clickedOption = optionEl;
    variantOptions.forEach((node) => node.classList.remove('selected'));
    clickedOption.classList.add('selected');
    const newVariantId = clickedOption.dataset.variantId;
    if (variantInput) {
      variantInput.value = newVariantId;
    }
    window.currentVariant = window.variantData.find((variant) => {
      return variant.id == newVariantId;
    });
    const addToCartBtn = document.querySelector('.product-form__buttons input[type="submit"]');
    const klaviyoBis = document.getElementById('klaviyo-bis-button-container');

    // check if currentVariant and addToCartBtn exist
    if (!window.currentVariant || !addToCartBtn) return;

    // Update Add to Cart button state
    if (window.currentVariant.available === false) {
      addToCartBtn.setAttribute('disabled', 'disabled');
      addToCartBtn.classList.add('is-disabled');
      addToCartBtn.value = window.sptranslation['product.out_of_stock'];

      // Show Klaviyo BIS button if it exists
      if (klaviyoBis) klaviyoBis.style.display = 'block';
    } else {
      addToCartBtn.removeAttribute('disabled');
      addToCartBtn.classList.remove('is-disabled');
      addToCartBtn.value = window.sptranslation['product.add_to_cart'];

      // Hide Klaviyo BIS button if it exists
      if (klaviyoBis) klaviyoBis.style.display = 'none';
    }

    if (variantLabel) {
      variantLabel.textContent = window.currentVariant.title.replace(recommended_text, '');
    }

    // Update URL without reloading
    if (window.currentVariant) {
      const url = new URL(window.location);
      url.searchParams.set('variant', window.currentVariant.id);
      window.history.replaceState({}, '', url);
    }

    updateMainPriceDisplay();

  };

const productForm = document.querySelector('.product-form form');
if (productForm) {
  const triggerPriceUpdate = () => {
    setTimeout(() => {
      updateMainPriceDisplay();
    }, 10);
  };
  productForm.addEventListener('change', triggerPriceUpdate);
  productForm.addEventListener('click', (e) => {
    // Only trigger if they click inside the subscription block
    if (e.target.closest('.subscription__blocks')) {
      triggerPriceUpdate();
    }
  });
}

// Ensure Recharge's async widget is synced on page load
const ensurePriceSync = () => {
  if (!window.currentVariant && window.variantData && window.variantData.length > 0) {
    let vId = variantInput ? variantInput.value : null;
    window.currentVariant = window.variantData.find((v) => v.id == vId) || window.variantData[0];
  }
  updateMainPriceDisplay();
};

  variantOptions.forEach((option) => {
    option.addEventListener('click', function () {
      updateSelectedVariant(this); // 'this' refers to the clicked option
    });
  });

  // Initialize selected variant on page load
  document.addEventListener('DOMContentLoaded', function () {
    const selectedOption =
      document.querySelector('[data-variant-option].selected') || document.querySelector('[data-variant-option]');
    
    if (selectedOption) {
      updateSelectedVariant(selectedOption); // init function on page load
    } else if (variantInput && variantInput.value) {
      // Fallback for single-variant products where option boxes are hidden
      window.currentVariant = window.variantData.find((variant) => variant.id == variantInput.value);
      updateMainPriceDisplay();
    }
  });

  // B2B Volume Pricing: Update quantity rules when variant changes
  const quantityRulesData = document.querySelector('[data-quantity-rules]');
  if (quantityRulesData) {
    try {
      window.quantityRulesData = JSON.parse(quantityRulesData.textContent);
    } catch (e) {
      window.quantityRulesData = {};
    }

    const updateQuantityRules = (variantId) => {
      const rules = window.quantityRulesData[variantId];
      if (!rules) return;

      const incrementer = document.querySelector('.ep-incrementer');
      if (!incrementer) return;

      const minValue = rules.min || 1;
      const maxValue = rules.max || 100;
      const step = rules.increment || 1;

      // Update incrementer data attributes FIRST
      incrementer.dataset.min = minValue;
      incrementer.dataset.max = maxValue;
      incrementer.dataset.step = step;

      // Use the exposed updateValue method if available, otherwise update manually
      if (incrementer._updateValue) {
        incrementer._updateValue(minValue);
      } else {
        // Fallback: Reset quantity to min value manually
        const valueDisplay = incrementer.querySelector('.ep-incrementer__number');
        const hiddenInput = incrementer.querySelector('.ep-incrementer__input');
        const minusButton = incrementer.querySelector('[data-action="decrement"]');
        const plusButton = incrementer.querySelector('[data-action="increment"]');

        if (valueDisplay) valueDisplay.textContent = minValue;
        if (hiddenInput) hiddenInput.value = minValue;
        if (minusButton) minusButton.disabled = true;
        if (plusButton) plusButton.disabled = minValue >= maxValue;
      }

      // Update or add unit label
      let unitLabel = incrementer.querySelector('[data-unit-label]');
      const valueContainer = incrementer.querySelector('.ep-incrementer__value');

      if (step > 1) {
        if (!unitLabel && valueContainer) {
          unitLabel = document.createElement('span');
          unitLabel.className = 'ep-incrementer__unit ep-body ep-body--caption';
          unitLabel.setAttribute('data-unit-label', '');
          unitLabel.textContent = 'units';
          valueContainer.appendChild(unitLabel);
        }
      } else if (unitLabel) {
        unitLabel.remove();
      }

      // Update volume pricing display
      updateVolumePricingDisplay(rules);
    };

    const updateVolumePricingDisplay = (rules) => {
      const volumePricing = document.querySelector('[data-volume-pricing]');
      if (!volumePricing) return;

      const minValue = rules.min || 1;

      // Update increment label
      const incrementLabel = volumePricing.querySelector('[data-increment-label]');
      if (incrementLabel) {
        if (rules.increment > 1) {
          incrementLabel.textContent = `Sold in multiples of ${rules.increment} units`;
          incrementLabel.style.display = '';
        } else {
          incrementLabel.style.display = 'none';
        }
      }

      // Update minimum label
      const minimumLabel = volumePricing.querySelector('[data-minimum-label]');
      if (minimumLabel) {
        if (minValue > 1) {
          minimumLabel.textContent = `(Minimum: ${minValue} units)`;
          minimumLabel.style.display = '';
        } else {
          minimumLabel.style.display = 'none';
        }
      }

      // Update price breaks table
      const tableContainer = volumePricing.querySelector('.volume-pricing__table');
      if (tableContainer && rules.price_breaks) {
        // Clear existing tiers (keep header)
        const existingTiers = tableContainer.querySelectorAll('.volume-pricing__tier');
        existingTiers.forEach((tier) => tier.remove());

        // Add new tiers
        rules.price_breaks.forEach((priceBreak, index) => {
          const nextBreak = rules.price_breaks[index + 1];
          const maxQty = nextBreak ? nextBreak.minimum_quantity - 1 : null;

          const tierEl = document.createElement('div');
          tierEl.className = 'volume-pricing__tier';
          tierEl.setAttribute('data-min-qty', priceBreak.minimum_quantity);

          const qtyRange = maxQty ? `${priceBreak.minimum_quantity} - ${maxQty}` : `${priceBreak.minimum_quantity}+`;

          tierEl.innerHTML = `
            <span class="volume-pricing__qty-range ep-body ep-body--small">${qtyRange}</span>
            <span class="volume-pricing__tier-price ep-body ep-body--small">${priceBreak.price_formatted}</span>
          `;

          tableContainer.appendChild(tierEl);
        });

        // Show/hide volume pricing based on price breaks
        if (rules.price_breaks.length > 0) {
          volumePricing.style.display = '';
        }
      }
    };

    // Hook into variant selection
    const originalUpdateSelectedVariant = window.updateSelectedVariant || updateSelectedVariant;
    variantOptions.forEach((option) => {
      option.addEventListener('click', function () {
        const variantId = this.dataset.variantId;
        setTimeout(() => updateQuantityRules(variantId), 10);
      });
    });

    // Initialize on page load
    document.addEventListener('DOMContentLoaded', function () {
      const selectedOption = document.querySelector('[data-variant-option].selected');
      if (selectedOption) {
        updateQuantityRules(selectedOption.dataset.variantId);
      }
    });
  }

  // Selling plan label functionality
  const sellingPlanLabel = document.querySelector('[data-selling-plan-label]');
  const sellingPlansData = document.querySelector('[data-selling-plans]');

  if (sellingPlanLabel && sellingPlansData) {
    try {
      window.sellingPlansData = JSON.parse(sellingPlansData.textContent);
    } catch (e) {
      window.sellingPlansData = {};
    }
    let lastSellingPlanValue = '';

    const updateSellingPlanLabel = (sellingPlanId) => {
      // Prevent unnecessary updates
      if (sellingPlanId === lastSellingPlanValue) return;
      lastSellingPlanValue = sellingPlanId;

      if (!sellingPlanId || sellingPlanId === '') {
        sellingPlanLabel.textContent = '';
        return;
      }

      // Try to find the plan - check both string and number keys
      const plan = window.sellingPlansData[sellingPlanId] || window.sellingPlansData[String(sellingPlanId)];

      if (plan && plan.name) {
        // Use plan name as the display text (e.g., "(Delivery Every 30 Days)")
        sellingPlanLabel.textContent = ` (${plan.name})`;
      } else {
        sellingPlanLabel.textContent = '';
      }
    };

    // Watch for selling_plan input changes (ReCharge widget updates this hidden input)
    const productForm = document.querySelector('.product-form form');
    if (productForm) {
      // Override the value setter on selling_plan inputs to detect programmatic changes
      const hookInputValueSetter = (input) => {
        if (input._valueSetterHooked) return;
        input._valueSetterHooked = true;

        const descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
        Object.defineProperty(input, 'value', {
          get: function () {
            return descriptor.get.call(this);
          },
          set: function (val) {
            descriptor.set.call(this, val);
            updateSellingPlanLabel(val);
          },
        });
      };

      // Check for existing input and hook it
      const existingInput = productForm.querySelector('input[name="selling_plan"]');
      if (existingInput) {
        hookInputValueSetter(existingInput);
        updateSellingPlanLabel(existingInput.value);
      }

      // Watch for the input being added dynamically (ReCharge may add it later)
      const observer = new MutationObserver((mutations) => {
        const input = productForm.querySelector('input[name="selling_plan"]');
        if (input && !input._valueSetterHooked) {
          hookInputValueSetter(input);
          updateSellingPlanLabel(input.value);
        }
      });
      observer.observe(productForm, { childList: true, subtree: true });

      // Also listen for clicks on the subscription widget as a backup
      const subscriptionBlocks = document.querySelector('.subscription__blocks');
      if (subscriptionBlocks) {
        subscriptionBlocks.addEventListener('click', () => {
          // Small delay to let ReCharge update the input
          setTimeout(() => {
            const input = productForm.querySelector('input[name="selling_plan"]');
            updateSellingPlanLabel(input ? input.value : '');
          }, 50);
        });
      }
    }
  }

  // Auto-click first variant after ReCharge widget initializes (non-B2B only)
  const isB2BCustomer = document.querySelector('[name="is_b2b_customer"]')?.value === 'true';
  console.log('[Variant Auto-Click] B2B customer:', isB2BCustomer);

  if (!isB2BCustomer) {
    let variantClickTriggered = false;

    const triggerFirstVariantClick = (source) => {
      if (variantClickTriggered) {
        console.log('[Variant Auto-Click] Already triggered, skipping:', source);
        return;
      }
      variantClickTriggered = true;

      const firstVariant = document.querySelector('[data-variant-option]');
      if (firstVariant) {
        console.log('[Variant Auto-Click] Triggering click via:', source);
        console.log('[Variant Auto-Click] Variant element:', firstVariant);
        firstVariant.click();
      } else {
        console.warn('[Variant Auto-Click] No variant element found');
      }
    };

    // ReCharge widget ready callback
    window.RechargeSubscriptionWidgetReady = function (data) {
      console.log('[Variant Auto-Click] RechargeSubscriptionWidgetReady fired', data);
      
      // Update our dynamic price now that Recharge is fully loaded
      if (typeof ensurePriceSync === 'function') {
        ensurePriceSync();
      }
      
      setTimeout(() => triggerFirstVariantClick('RechargeSubscriptionWidgetReady'), 500);
    };

    // Fallback timeout in case ReCharge callback doesn't fire
    // (e.g., widget fails to load or product has no subscriptions)
    document.addEventListener('DOMContentLoaded', () => {
      console.log('[Variant Auto-Click] DOMContentLoaded, setting 2s fallback timeout');
      setTimeout(() => {
        if (!variantClickTriggered) {
          console.log('[Variant Auto-Click] Fallback timeout reached');
          triggerFirstVariantClick('fallback timeout');
        }
      }, 2000);
    });
  } else {
    console.log('[Variant Auto-Click] Skipping auto-click for B2B customer');
  }
  } catch(e) { console.error(e); }
})();

})();
